import './stylex.css'
// should be on top to avoid swr client not found error
import './initSWRHelper'
// rest
import { datadogRum } from '@datadog/browser-rum'
import { AnalyticsProvider } from '@dni-analysis'
import { ThemeProvider as MuiThemeProvider, THEME_ID, createTheme } from '@mui/material/styles'
import { ThemeProvider } from '@pets-ui/ThemeProvider/ThemeProvider'
import { colorTheme } from '@pets-ui/themes/fastpass'
import { withCampaignNotFound, withDestructuredResponse, withCampaignGroupBuyingError } from '@utils/swr'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom-v5'
import { SWRConfig } from 'swr'
import App from './App'
import { TheScrollToTop } from './components/the-scroll-to-top'
import { initDniAnalysis } from './initDniAnalysis'
import { store } from './store/store'
import './style/global.scss'

if (import.meta.env.VITE_APP_ENV === 'production') {
  const IGNORED_HTTP_STATUS_CODE = [403]
  datadogRum.init({
    applicationId: '66835a5f-c738-4c5b-ad1d-30559b40fee3',
    clientToken: 'pub22bb23f8889702c9bd15cb8c4185e367',
    site: 'us3.datadoghq.com',
    service: 'fastpass',
    env: import.meta.env.VITE_APP_ENV,
    version: import.meta.env.APP_VERSION,
    defaultPrivacyLevel: 'mask-user-input', // 避免收集敏感資訊
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 5,
    beforeSend: (event) => {
      if (event.type === 'resource'
        && event.resource.type === 'xhr'
        && event.resource.status_code !== undefined
        && IGNORED_HTTP_STATUS_CODE.includes(event.resource.status_code)
      ) {
        return false
      }
      return true
    },
  })
}

initDniAnalysis()

const rootElement = document.getElementById('root') as HTMLElement
console.log(`%c${import.meta.env.APP_INFO}`, 'font-size: large', import.meta.env.ASCII)

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <ThemeProvider theme={colorTheme}>
      <MuiThemeProvider theme={{ [THEME_ID]: createTheme() }}>
        <HelmetProvider>
          <Provider store={store}>
            <BrowserRouter>
              <AnalyticsProvider>
                <TheScrollToTop />
                <SWRConfig value={{ use: [withDestructuredResponse, withCampaignNotFound, withCampaignGroupBuyingError] }}>
                  <App />
                </SWRConfig>
              </AnalyticsProvider>
            </BrowserRouter>
          </Provider>
        </HelmetProvider>
      </MuiThemeProvider>
    </ThemeProvider>
  </React.StrictMode>,
)
